@if (showWarning()) {
  <div
    class="icon-wrapper"
    (mouseenter)="showTooltip()"
    (mouseleave)="hideTooltip()"
  >
    <img
      class="warning-icon"
      [src]="'/images/warning.svg'" 
      alt="Warning"
    />
  </div>

  <ng-template #tooltipTemplate>
    <lib-tooltip
      [message]="tooltipText()"
      iconAlt="Warning"
      [isWarning]="true"
    />
  </ng-template>
}